import * as Yup from 'yup';
import {
  REQUIRED_FIELD_ERROR,
  TOTAL_INFO_ERROR,
} from '../../../../utils/constants';
import { ImageListType } from 'react-images-uploading';

const useBasicValidationSchema = () => {
  const validationSchema = Yup.object().shape({
    objectName: Yup.string()
      .max(60, TOTAL_INFO_ERROR)
      .min(3, TOTAL_INFO_ERROR)
      .required(REQUIRED_FIELD_ERROR),

    objectType: Yup.string().required(REQUIRED_FIELD_ERROR),

    country: Yup.string().required(REQUIRED_FIELD_ERROR),

    region: Yup.string()
      .required(REQUIRED_FIELD_ERROR)
      .max(60, TOTAL_INFO_ERROR)
      .min(3, TOTAL_INFO_ERROR),

    locality: Yup.string()
      .required(REQUIRED_FIELD_ERROR)
      .max(60, TOTAL_INFO_ERROR)
      .min(3, TOTAL_INFO_ERROR),

    address: Yup.string()
      .required(REQUIRED_FIELD_ERROR)
      .max(60, TOTAL_INFO_ERROR)
      .min(3, TOTAL_INFO_ERROR),

    bookingImage: Yup.string().nullable(),

    newBookingImage: Yup.mixed<ImageListType>(),

    homeImage: Yup.string().nullable(),

    newHomeImage: Yup.mixed<ImageListType>(),

    rulesPdf: Yup.mixed<File | string>()
      .nullable()
      .test('fileType', 'Файл должен быть PDF', (value) => {
        if (!value) return true;
        if (typeof value === 'string') return true; // URL — пропускаем
        return value.type === 'application/pdf';
      })
      .test('fileSize', 'Файл превышает 5 Мб', (value) => {
        if (!value || typeof value === 'string') return true;
        return value.size <= 5 * 1024 * 1024;
      })
      .test('fileEmpty', 'Файл не должен быть пустым', (value) => {
        if (!value || typeof value === 'string') return true;
        return value.size > 0;
      }),

      textRules: Yup.string()
      .max(10000, TOTAL_INFO_ERROR)     
  });
  return validationSchema;
};

export default useBasicValidationSchema;
